var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.828 22q-.675 0-1.16-.45a1.84 1.84 0 0 1-.587-1.1l-.224-1.65a4 4 0 0 1-.612-.3 8 8 0 0 1-.56-.375l-1.548.65q-.623.275-1.247.05a1.84 1.84 0 0 1-.973-.8l-1.173-2.05a1.6 1.6 0 0 1-.2-1.225q.15-.65.674-1.075l1.323-1a2.4 2.4 0 0 1-.025-.338v-.675q0-.162.025-.337l-1.323-1a1.9 1.9 0 0 1-.673-1.075 1.6 1.6 0 0 1 .2-1.225l1.172-2.05a1.84 1.84 0 0 1 .973-.8q.624-.225 1.247.05l1.547.65a7 7 0 0 1 .574-.375q.3-.175.599-.3l.224-1.65q.1-.65.586-1.1.487-.45 1.16-.45h2.345q.674 0 1.16.45.487.45.587 1.1l.224 1.65q.325.125.612.3.286.175.56.375l1.548-.65q.623-.275 1.247-.05t.973.8l1.173 2.05q.348.575.2 1.225-.15.65-.674 1.075l-1.323 1q.025.176.025.338v.675q0 .162-.05.337l1.323 1q.523.425.673 1.075t-.2 1.225l-1.197 2.05a1.84 1.84 0 0 1-.973.8q-.623.225-1.247-.05l-1.497-.65a7 7 0 0 1-.574.375q-.3.175-.599.3l-.224 1.65a1.84 1.84 0 0 1-.586 1.1q-.487.45-1.16.45zm1.222-6.5q1.447 0 2.47-1.025A3.38 3.38 0 0 0 15.543 12q0-1.45-1.023-2.475A3.36 3.36 0 0 0 12.05 8.5q-1.472 0-2.482 1.025T8.558 12t1.01 2.475T12.05 15.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFill);
export default __webpack_public_path__ + "static/media/Settings_fill.5df9b18e931ddd535d7f81a0f44f1ff1.svg";
export { ForwardRef as ReactComponent };